/* eslint-disable @typescript-eslint/brace-style */
import { useNavigate, useLocation } from 'react-router-dom';
import { UserProfile } from 'api/account/models/UserProfile';
import { Paged } from 'api/common/types/Page';
import IdentificationTagsService from 'api/identificationTags/IdentificationTagsService';
import { IdentificationTagDto } from 'api/identificationTags/models/IdentificationTagDto';
import { IdentificationTagSearchCriteria } from 'api/identificationTags/models/IdentificationTagSearchCriteria';
import UsersService from 'api/users/UsersService';
import ListingTable, { ListingTableColumn } from 'common/components/listingTable/ListingTable';
import PaginationWithInfo from 'common/components/pagination/PaginationWithInfo';
import QuestionYesNo from 'common/components/questionYesNo/QuestionYesNo';
import Logger from 'common/services/Logger';
import { DEFAULT_PAGINATION_ITEMS_PER_PAGE, LOGGER_LOG_TYPE } from 'Config';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Reducers } from 'store/types';
import styles from './IdentificationTagsScreen.module.scss';
import ScreenTitle from 'common/components/screenTitle/ScreenTitle';
import toast from 'react-hot-toast';
import { Button, Container, Dropdown, Stack, Form, Card, Breadcrumb } from 'react-bootstrap';
import Loading from 'common/services/Loading';

type Props = {
};

const IdentificationTagsScreen: React.FC<Props> = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    const [criteria, setCriteria] = useState<IdentificationTagSearchCriteria>({
        itemsPerPage: DEFAULT_PAGINATION_ITEMS_PER_PAGE,
        page: 1,
        orderBy: 'asc',
        orderColumn: 'it.code'
    });
    const [identificationTagsPage, setIdentificationTagsPage] = useState<Paged<IdentificationTagDto>>();
    const userProfile = useSelector<Reducers, UserProfile | null>(state => state.authentication.profile);
    const hasIdentificationTagsWritePolicy = UsersService.hasPolicies(userProfile?.policies || [], ['CONFIG_IDENTIFICATION_TAGS_WRITE']);
    const hasMyIdentificationTagsWritePolicy = UsersService.hasPolicies(userProfile?.policies || [], ['MY_IDENTIFICATION_TAGS_WRITE']);
    const hasMyIdentificationTagsReadPolicy = UsersService.hasPolicies(userProfile?.policies || [], ['MY_IDENTIFICATION_TAGS_READ']);
    const [filters, setFilters] = useState({
        allIn: ''
    });
    const getData = async () => {
        try {
            console.log('RRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRR')
            Loading.show();
            const page = await IdentificationTagsService.getList(criteria);
            setIdentificationTagsPage(page);
        } catch (error) {
            Logger.error(LOGGER_LOG_TYPE.REQUEST, 'Couldn\'t get IdentificationTags list', error);
            toast.error(t('messages.error_load_info'));
        } finally {
            Loading.hide();
        }
    }

    const renderTableActionCell = (row: IdentificationTagDto) => {
        return <Dropdown>
            <Dropdown.Toggle id="dropdown-basic-button" size="sm" variant="outline-secondary">...</Dropdown.Toggle>
            <Dropdown.Menu popperConfig={{ strategy: 'fixed' }} renderOnMount>
                <Dropdown.Item onClick={() => navigate(`/identificationtags/details/${row.id}`)}>{t('common.details')}</Dropdown.Item>
                {hasIdentificationTagsWritePolicy && <>
                    <Dropdown.Item onClick={() => navigate(`/identificationtags/edit/${row.id}`)}>{t('common.edit')}</Dropdown.Item>
                    <Dropdown.Item onClick={() => showRemoveItemDialog(row)}>{t('common.delete')}</Dropdown.Item>
                </>
                }
            </Dropdown.Menu>
        </Dropdown>
    };

    const onTableFilter = (field: string, isFilterAsc: boolean) => {
        setCriteria({ ...criteria, page: 1, orderBy: (isFilterAsc ? 'asc' : 'desc'), orderColumn: field });
    }

    const tableColumns: ListingTableColumn<IdentificationTagDto>[] = useMemo(() => {
        const cols: ListingTableColumn<IdentificationTagDto>[] = [
            {
                field: 'code',
                name: t('identification_tags.list.code') ?? '',
                onSearch: onTableFilter,
                searchField: 'code'
            }];

        if (hasMyIdentificationTagsWritePolicy || hasMyIdentificationTagsReadPolicy)
        {
            cols.push(
                {
                    field: 'driverName',
                    name: t('identification_tags.list.driver') ?? '',
                    onSearch: onTableFilter,
                    searchField: 'p.name'
                });
        }

        cols.push(
            {
                field: 'companyName',
                name: t('identification_tags.list.company') ?? '',
                onSearch: onTableFilter,
                searchField: 'c.name'
            });

        cols.push(
            {
                name: '',
                width: '60px',
                cellAlignment: 'right',
                preventClick: true,
                renderCell: renderTableActionCell,
                cellStyle: { overflow: 'unset' }
            });

        return cols;
    }, []);

    const [showRemoveModal, setShowRemoveModal] = useState<boolean>(false);
    const [itemToRemove, setItemToRemove] = useState<IdentificationTagDto | null>(null);

    const showRemoveItemDialog = async (item: IdentificationTagDto) => {
        setItemToRemove(item);
        setShowRemoveModal(true);
    }

    const onRowClick = (event: any, id?: string) => {
        if (id) {
            if (event.ctrlKey) {
                window.open(location.pathname + '/details/' + id, '_blank');
                return;
            }
            navigate(`/identificationtags/details/${id}`);
        }
    }

    const onCancelRemove = () => {
        setItemToRemove(null);
        setShowRemoveModal(false);
    };

    const onRemove = async () => {
        if (itemToRemove === null) {
            toast.error(t('messages.record_delete_error'));
            return;
        }
        try {
            await IdentificationTagsService.remove(itemToRemove);
            onCancelRemove();
            toast.success(t('messages.record_delete_success'));
            setCriteria({ ...criteria, page: 1 })
        }
        catch (error) {
            Logger.error(LOGGER_LOG_TYPE.REQUEST, 'Couldn\'t delete simCards', error);
            toast.error(t('messages.record_delete_error'));
        }
    };

    useEffect(() => {
        getData().catch(console.error);
    }, [criteria]);

    function handleChange(e: any) {
        const key = e.target.name;
        const value = e.target.value;
        setFilters({ ...filters, [key]: value });
    }
    function clearFilters() {
        setFilters({ allIn: '' });
        setCriteria({ ...criteria, page: 1, allIn: '' });
    }
    const onSearch = () => {
        setCriteria({ ...criteria, allIn: filters.allIn });
    }

    return (
        <ScreenTitle title={t('identification_tags.title')}>
            <Breadcrumb>
                <Breadcrumb.Item active>{t('identification_tags.title')}</Breadcrumb.Item>
            </Breadcrumb>
            <Container fluid>
                <Card className={styles.filters}>
                    <Card.Body>
                        <Stack direction="horizontal" gap={3} >
                            <Form.Control type="text" value={filters.allIn} className="me-auto" name="allIn" onChange={handleChange} onKeyDown={(e: any) => { if (e.key === 'Enter') onSearch(); }} placeholder={t('common.write_here')} />
                            <Button variant="secondary" onClick={onSearch}>{t('common.search')}</Button>
                            <div className="vr" />
                            <Button variant="outline-danger" onClick={clearFilters}>{t('common.clear')}</Button>
                            {hasIdentificationTagsWritePolicy && <Button variant="primary" onClick={() => navigate('/identificationtags/new/')}>{t('common.new')}</Button>}
                        </Stack>
                    </Card.Body>
                </Card>
            </Container>
            <Container fluid>
                <ListingTable
                    columns={tableColumns}
                    rows={identificationTagsPage?.items || []}
                    onRowClick={(row, _, event) => onRowClick(event, row.id)}
                    allowHover={true}
                    initialSearch={{ colField: 'c.code', isOrderAsc: true }}
                />
                <PaginationWithInfo
                    itemName={t('identification_tags.title')}
                    currentPage={identificationTagsPage?.currentPage ?? 1}
                    pageItems={identificationTagsPage?.items?.length || 0}
                    totalItems={identificationTagsPage?.totalItems || 0}
                    onChange={page => setCriteria({ ...criteria, page })}
                />
            </Container>
            <QuestionYesNo onNo={onCancelRemove} onYes={onRemove} isVisible={showRemoveModal} message={t('messages.remove_record_with_ident', { name: itemToRemove?.code ?? '' })} />
        </ScreenTitle>
    );
};

export default IdentificationTagsScreen;
